export type KonvaAnnotationDragPreviewDetail = {
  delta: { x: number; y: number }
  draggingId: string
}

export const KONVA_ANNOTATION_DRAG_PREVIEW_EVENT =
  'q20:konva-annotation-drag-preview'

export const dispatchKonvaAnnotationDragPreview = (
  detail: KonvaAnnotationDragPreviewDetail,
) => {
  window.dispatchEvent(
    new CustomEvent<KonvaAnnotationDragPreviewDetail>(
      KONVA_ANNOTATION_DRAG_PREVIEW_EVENT,
      { detail },
    ),
  )
}
